// eslint-disable
import React from 'react';
import { Link } from 'react-router-dom';
import ReactHtmlParser from 'react-html-parser';
import styled from 'styled-components';
import { MessageDescriptor } from 'react-intl';
import { localizePathname } from '@whitelabel/helpers/i18n';
import { captureExceptionWithFullyStory } from '@whitelabel/helpers/utils';
import { parseURL } from './url';

// TODO: Clean up these date and number functions, react-intl should be handling a lot of it out of the box
export const renderAmountWithSymbol = (amount: any, currency: any, locale = null) =>
  // @ts-ignore ts-migrate(2345) FIXME: Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
  new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
  }).format(amount);

export const localizeURL = (url: any, locale: any) => {
  // @ts-ignore ts-migrate(2339) FIXME: Property 'origin' does not exist on type '{ pathna... Remove this comment to see the full error message
  const { origin, pathname, search, hash } = parseURL(url);
  const localizedPathname = localizePathname(pathname, locale);
  const localizedURL = `${origin || ''}${localizedPathname}${search}${hash}`;
  return localizedURL;
};

export const localizeLocation = (location: any, locale: any) => {
  const { pathname, state } = location;

  if (state && state.referrer) {
    state.referrer.pathname = localizePathname(state.referrer.pathname, locale);
  }

  return {
    ...location,
    pathname: localizePathname(pathname, locale),
    state,
  };
};

function formatAttributes(attribs: any) {
  let result = '';
  if (attribs) {
    result = Object.entries(attribs)
      .map(([name, value]) => `${name}="${value}"`)
      .join(' ');
  }
  return result;
}

function formatChildren(children: any) {
  let result = '';
  children.forEach((element: any) => {
    if (element.type === 'text') {
      result += element.data;
    } else if (element.type === 'tag') {
      result += `<${element.name} ${formatAttributes(element.attribs)}>${formatChildren(element.children)}</${
        element.name
      }>`;
    }
  });
  return result;
}

export const transformLink = (intl: any) => (node: any) => {
  if (node.type === 'tag' && node.name === 'a') {
    if (!node.attribs.href) {
      const error = new Error('HTML a tag is missing a valid href attribute');
      captureExceptionWithFullyStory(error);
      return;
    }
    if (node.attribs.href.startsWith('/')) {
      const path = localizePathname(node.attribs.href, intl.locale);

      return (
        <Link key={path} to={path}>
          {ReactHtmlParser(formatChildren(node.children))}
        </Link>
      );
    }
  }
  return undefined;
};

export const formatCurrency = (intl: any, value: any, currency: any) => {
  if (!value) return value;
  return intl.formatNumber(value, { style: 'currency', currency });
};

export const renderMessageWithID = (intl: any) => {
  const StyledMessageContainerSpan = styled.span`
    position: relative;
  `;
  const StyledMessageIDSpan = styled.span`
    z-index: 100;
    top: -1.5em;
    position: absolute;
    display: inline-block;
    visibility: hidden;
    padding: 0.25rem;
    background: white;
    border-radius: 0.2rem;
    cursor: pointer;
  `;

  let storedID: string | number | undefined = '';
  document.addEventListener('keydown', function (e) {
    if (e.shiftKey) {
      navigator.clipboard.writeText(storedID as string);
    }
  });

  const handleMouseOver = (id: MessageDescriptor['id']) => {
    const idEl = document.getElementById(`message-${id}`);
    if (!idEl) return;
    storedID = id;
    idEl.style.visibility = 'visible';
    setTimeout(() => {
      idEl.style.visibility = 'hidden';
    }, 2000);
  };

  const old = intl.formatMessage;

  // eslint-disable-next-line react/display-name
  intl.formatMessage = ({ id, defaultMessage }: MessageDescriptor) => {
    return (
      <StyledMessageContainerSpan
        onFocus={() => {
          return;
        }}
        onMouseOver={() => handleMouseOver(id)}
      >
        <StyledMessageIDSpan id={`message-${id}`}>{id} </StyledMessageIDSpan>
        {old({ id, defaultMessage })}
      </StyledMessageContainerSpan>
    );
  };
};
